import { useState, type ReactNode } from 'react';
import { LoaderContext } from './LoaderContext';

type Props = {
    children: ReactNode;
};

export const LoaderProvider = ({ children }: Props) => {
    const [loading, setLoading] = useState(false);

    const showLoader = () => setLoading(true);
    const hideLoader = () => setLoading(false);

    return (
        <LoaderContext.Provider value={{ loading, setLoading, showLoader, hideLoader }}>
            {children}

            {loading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
                    <div className="h-10 w-10 animate-spin rounded-full border-4 border-white border-t-transparent"></div>
                </div>
            )}
        </LoaderContext.Provider>
    );
};
